import { FC, useState, useEffect, Fragment } from "react";
import { Box, Grid, Typography } from "@mui/material";
import {
  CommonStyle,
  // ControlledForm, 
  ControlledTable
} from "Components";
import { ModalLayout, TableLayout } from "Layouts";
import CstmBtn from "Components/CstmBtn";
import { useNavigate } from "react-router-dom";
import PatientApi from "Service/Patient.api";
import { FormDataType } from "DataTypes/Form";
import { commonFormSwitch } from "Utils/SwitchCases";
import { useSelector } from "react-redux";
import {
  CheckStringEmpty,
  HandleFormChange,
  ValidateFormData
} from "Utils/common";
import { FormDataArr, TableCol } from "./Data";
import { RouteUrls } from "Constant/RouteUrls";
import { useDispatch } from "react-redux";
import {
  setAlertData,
  setLeftHead,
  startLoading,
  stopLoading,
} from "Redux/Screen/Action";
import {
  ListInitialStateType,
  PatientInitialStateType,
  UserInitialStateType,
} from "DataTypes/Redux";
import DateTime from "Utils/DateTime";
import {
  CommonButtonArray,
  // SingleBtnArray 
} from "Components/Modal/Data";
import PatientFormatter from "Utils/Patient.Formatter";
import {
  CallLogListType,
  // UnenrolledPrgmType
} from "DataTypes/Services/Patient.type";
import { addPatientInfo } from "Redux/Patient/Action";
import CommonFormatter from "Utils/Common.Formatter";

const CallLogs: FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { patientInfo, selectedPrgm }: PatientInitialStateType = useSelector(
    (state: any) => state?.patient
  );
  // const { unreachableReasonList }: ListInitialStateType = useSelector(
  //   (state: any) => state?.list
  // );
  const newPatientId = patientInfo.id;
  const readOnly = selectedPrgm.readOnlyArr.some((el) => el == "call-log");
  const { callResultList }: ListInitialStateType = useSelector(
    (state: any) => state?.list
  );
  const { myInfo }: UserInitialStateType = useSelector(
    (state: any) => state?.user
  );
  const [rowData, setRowData] = useState<CallLogListType[]>([]);
  const [limit, setLimit] = useState<number>(10);
  const [page, setPage] = useState<number>(1);
  const [totalRecord, setTotalRecord] = useState(0);
  const [formArr, setFormArr] = useState<FormDataType[]>([]);
  const [loading, setLoading] = useState(true);
  const [openModal, setOpenModal] = useState(false);
  // const [unenrolledPrgmList, setUnenrollPrgmList] =
  //   useState<UnenrolledPrgmType[] | null>(null);
  // const [reason, setReason] = useState("");
  // const openModal = Array.isArray(unenrolledPrgmList)
  const showSaveNextBtn =
    formArr[2]?.dropValue == "answered" ||
    formArr[2]?.dropValue == "in_person" ||
    formArr[2]?.dropValue == "unreachable"

  useEffect(() => {
    handleSetFormData();
    dispatch(setLeftHead("patient-details"));
    CommonFormatter.HandleNavArr({
      id: "patient-call-logs",
      label: "Call Logs",
      path: `/${RouteUrls.hs}/${RouteUrls.patient}` +
        `/${patientInfo.id}/${RouteUrls.callLog}`,
      level: 3,
      link: RouteUrls.callLog,
      navType: "patient",
    });
    dispatch(addPatientInfo({ ...patientInfo, firstTimeNotesVisit: true }));
    return () => {
      dispatch(setLeftHead(""));
    };
  }, []);

  const handleSetFormData: () => void = () => {
    const UserName = `${myInfo?.firstname} ${myInfo?.lastname}`;
    const newFormData: FormDataType[] = JSON.parse(
      JSON.stringify(FormDataArr())
    );
    const newArr: FormDataType[] = newFormData?.map((el) => {
      if (el.id == "patient-lang") {
        el.value = patientInfo.language;
        el.readOnly = true;
        el.boxSize = 1
      }
      if (el.id == "call_name") {
        el.value = UserName;
        el.readOnly = true;
        el.boxSize = 2
      }
      if (el.id == "call_result") el.dropArr = callResultList;
      if (el.id == "next_call") el.minVal = DateTime.CurrentDateTime();
      return el;
    });
    setFormArr(newArr);
  };

  useEffect(() => {
    handleSetData(page, limit);
  }, [newPatientId]);

  const handleSetData: (
    currentPage: number,
    currentLimit: number
  ) => void = async (currentPage, currentLimit) => {
    setLoading(true);
    const res: any = await PatientApi.callLogList({
      offset: (currentPage - 1) * currentLimit,
      limit: currentLimit,
      id1: newPatientId,
    });
    if (res?.success) {
      setRowData(PatientFormatter.CallLogList(res?.data, callResultList));
      setTotalRecord(res?.criterion?.total);
      setPage(res?.criterion?.page);
      setLimit(res?.criterion?.limit);
    }
    setLoading(false);
  };

  const handleSubmit: (btnText: string) => void = async (btnText) => {
    const newArr = ValidateFormData(formArr);
    setFormArr(newArr.formData);
    if (!newArr.errorCheck) {
      dispatch(startLoading({ loading: true, loadtext: "Loading..." }));
      const newDate = CheckStringEmpty(newArr.formData[3].value);
      const payload = {
        notes: newArr.formData[4].value,
        callResult: newArr.formData[2].dropValue,
        nextCallDate: newDate ? DateTime.LocalTZToUTCDateTime(
          CheckStringEmpty(newDate)
        ) : "",
        programId: selectedPrgm?.programId,
        careplanId: selectedPrgm?.careplanId,
        careplanRecurringId: selectedPrgm?.careplanRecurringId,
      };
      const res = await PatientApi.callLogCreate({
        id1: newPatientId,
        data: payload,
      });
      if (res?.success) {
        handleSetData(page, limit);
        handleSetFormData();
        dispatch(setAlertData(res?.alert));
        if (btnText == "save-next") {
          navigate(
            `${selectedPrgm?.callDefaultRoute || "../" + RouteUrls.program}`,
            {
              state: {
                callResult: CheckStringEmpty(newArr.formData[2].dropValue)
              }
            }
          );
        }
        dispatch(stopLoading());
      }
    }
  };

  // const handleUnenrolledPrgmSearch: () => void = async () => {
  //   const res = await PatientApi.UnenrolledPrgmSearch({ id1: patientInfo.id });
  //   if (res?.success) {
  //     const formattedData = PatientFormatter.UnenrolledPrgmList(res?.data);
  //     setUnenrollPrgmList(formattedData);
  //   }
  // };

  // const handleUnreachableBtn: () => void = async () => {
  //   const payload = {
  //     concentReason: reason,
  //     eligibleProgramIds: unenrolledPrgmList?.map(el => el?.eligibleId) || []
  //   }
  //   const res = await PatientApi.UnreachableConsent({
  //     id1: patientInfo.id,
  //     data: payload
  //   });
  //   if (res?.success) {
  //     setUnenrollPrgmList(null);
  //   }
  // };

  const handleUnResponsiveBtn: () => void = async () => {
    const res = await PatientApi.callLogUnresponsive({
      id1: newPatientId,
    });
    if (res?.success) {
      dispatch(setAlertData(res?.alert));
    }
    setOpenModal(false);
  };

  const TblBodyJSX = (
    <ControlledTable.TblBody
      tableColumn={() => TableCol()}
      tableRow={rowData}
    />
  );

  return (
    <Box width="91%" sx={{ ...CommonStyle.sxWhiteCard }} overflow="auto">
      {/* <ModalLayout
        modwidth="40%"
        heading={"Unreachable"}
        content={
          unenrolledPrgmList ?
            unenrolledPrgmList?.length > 0 ?
              <Fragment>
                <Typography variant="body2">
                  Are you sure you want to mark the patient as Unreachable?
                  This will move the patient to Inactive, only for all
                  <b> Not Enrolled</b> programs, and close all
                  existing appointments for all such programs
                  in which patient is currently <b>Not Enrolled</b>.
                </Typography>
                <Box my={1}>
                  <ControlledForm.SingleSelectDrop
                    id="reason-drop"
                    dropArr={unreachableReasonList}
                    dropValue={reason}
                    label="Select a reason"
                    onClick={(val) => setReason(CheckStringEmpty(val))}
                    width={"50%"}
                    placeholder="Select a reason"
                  />
                </Box>
              </Fragment>
              :
              <Typography variant="body2">
                This patient is enrolled in all available programs.
                To mark patient as unreachable, please go to the
                Clinical Summary, select the specific program,
                and unenroll with the appropriate reason.
              </Typography>
            : <></>
        }
        open={openModal}
        onClose={() => setUnenrollPrgmList(null)}
        {...unenrolledPrgmList && unenrolledPrgmList?.length > 0 ? {
          buttonArr: CommonButtonArray(
            handleUnreachableBtn,
            () => setUnenrollPrgmList(null),
            "Confirm",
            "Cancel",
            reason ? false : true
          )
        } : {
          buttonArr: SingleBtnArray(() => setUnenrollPrgmList(null),)
        }}
        warning={true}
      /> */}
      <ModalLayout
        modwidth="33%"
        heading={"Unresponsive"}
        content={
          <Typography>
            {"Are you sure you want to mark " +
              patientInfo.name +
              " as Unresponsive? Patient will get Unenrolled from all " +
              "previously enrolled programs if marked as Unresponsive. " +
              "Also, previously created all appointments for Care Plan, " +
              "Recurring follow up or Call Reminder if any will get closed. " +
              "Confirm?"}
          </Typography>
        }
        open={openModal}
        onClose={() => setOpenModal(false)}
        buttonArr={CommonButtonArray(
          handleUnResponsiveBtn,
          () => setOpenModal(false),
          "Yes",
          "No"
        )}
        warning={true}
      />
      {!readOnly && (
        <Fragment>
          <Grid container rowSpacing={0} columnSpacing={1} height="14%">
            {formArr?.map((el: FormDataType) => {
              return (
                <Grid key={el.id} item sm={el.boxSize}>
                  {commonFormSwitch({
                    formObj: el,
                    onChange: (props) =>
                      setFormArr(HandleFormChange(props, formArr)),
                  })}
                </Grid>
              );
            })}
          </Grid>
          <Box
            height={"8%"}
            display="flex"
            flexDirection="row"
            justifyContent={"flex-end"}
            sx={{ "& >button": { ml: 1 } }}
          >
            {/* <CstmBtn
              label="Unreachable"
              onClick={handleUnenrolledPrgmSearch}
              btnType="border"
            /> */}
            <CstmBtn
              label="UNRESPONSIVE"
              onClick={() => setOpenModal(true)}
              btnType="border"
              title="Unresponsive-Never Answered"
            />
            <CstmBtn label={"Save"} onClick={() => handleSubmit("save")} />
            {
              showSaveNextBtn && (
                <CstmBtn
                  label={"Save & Next"}
                  onClick={() => handleSubmit("save-next")}
                />
              )}
            <CstmBtn
              label="Cancel"
              onClick={() => navigate(`../${RouteUrls.details}`)}
              btnType="border"
              title="Cancel"
            />
          </Box>
        </Fragment>
      )}
      <Typography
        sx={{
          height: "6%",
          display: "flex",
          flexDirection: "row",
          alignItems: "flex-end",
          ...CommonStyle.sxHeading,
        }}
      >
        Log History
      </Typography>
      <TableLayout
        tblBody={TblBodyJSX}
        tblHead={ControlledTable.TblHead(TableCol())}
        height={readOnly ? "92" : "72%"}
        loading={loading}
        Pagination={
          <ControlledTable.Pagination
            mainPage={page}
            limit={limit}
            total={totalRecord}
            handleClick={handleSetData}
            tableStyle={true}
          />
        }
      />
    </Box>
  );
};
export default CallLogs;
